<template>
    <div></div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';

    import { userSettingsService } from '@/services/userSettingsService'
    import { translationConfigService } from '@/features/TranslationConfig/translationConfigService'
    import { wwsUrlService } from '@/services/wwsUrlService'

    import { useUserStore } from '@/stores/userStore';

    export default defineComponent({
        data() {
            return {
                userStore: useUserStore(),
            };
        },
        created() {
            this.logoutActions();
        },
        methods: {
            async logoutActions() {
                await this.userStore.logout();
                translationConfigService.clearCache();
                userSettingsService.clearCache();

                window.location.href = wwsUrlService.logOutUrl();
            }
        },
    });
</script>
